import api from "./api";

// Sube el fichero y espera a que el servidor termine de procesarlo en segundo plano.
export async function uploadSales(fd, onProgress) {
  const { data } = await api.post("/sales/upload", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 300000 });
  const started = Date.now();
  for (;;) {
    await new Promise((r) => setTimeout(r, 3000));
    let job;
    try {
      job = (await api.get(`/sales/upload-jobs/${data.job_id}`)).data;
    } catch {
      continue;
    }
    if (job.status === "ok") return job.result;
    if (job.status === "error") {
      const err = new Error(job.error);
      err.response = { data: { detail: job.error } };
      throw err;
    }
    onProgress?.(Math.round((Date.now() - started) / 1000));
    if (Date.now() - started > 45 * 60 * 1000) throw new Error("El procesado está tardando demasiado");
  }
}
